var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserInitiatedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50033 9.50033C8.19404 9.50033 7.07577 9.03521 6.14553 8.10497C5.21529 7.17473 4.75017 6.05646 4.75017 4.75017C4.75017 3.44387 5.21529 2.3256 6.14553 1.39536C7.07577 0.46512 8.19404 0 9.50033 0C10.8066 0 11.9249 0.46512 12.8551 1.39536C13.7854 2.3256 14.2505 3.44387 14.2505 4.75017C14.2505 6.05646 13.7854 7.17473 12.8551 8.10497C11.9249 9.03521 10.8066 9.50033 9.50033 9.50033ZM0 19.0007V15.6755C0 15.0026 0.173183 14.3841 0.519549 13.82C0.865916 13.2559 1.32609 12.8254 1.90007 12.5286C3.12719 11.915 4.37411 11.4548 5.64082 11.148C6.90753 10.8413 8.19404 10.6879 9.50033 10.6879C10.8066 10.6879 12.0931 10.8413 13.3598 11.148C14.6266 11.4548 15.8735 11.915 17.1006 12.5286C17.6746 12.8254 18.1347 13.2559 18.4811 13.82C18.8275 14.3841 19.0007 15.0026 19.0007 15.6755V19.0007H0Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInitiatedIcon);
export default __webpack_public_path__ + "static/media/user-initiated-icon.239e116249d14dd23d95f94cdd589855.svg";
export { ForwardRef as ReactComponent };